<form *ngIf="form" [formGroup]="form">

    <div class="ui-g-12">
        <div class="ui-g-6 ui-md-6 form-control">
            <span class="label">{{ 'campaign.emissionStartDate' | translate }}</span>
            <p-calendar #emissionStartField data-testid="emissionStartField" [showIcon]="true" [inputStyleClass]="'form-control'"
                [dateFormat]="'yy-mm-dd'" [inputId]="'emissionDateStart'"
                [formControlName]="'emissionDateStart'"></p-calendar>
        </div>
        <div class="ui-g-6 ui-md-6 form-control">
            <span class="label">{{ 'campaign.emissionEndDate' | translate }}</span>
            <p-calendar #emissionEndField data-testid="emissionEndField" [showIcon]="true" [inputStyleClass]="'form-control'" [dateFormat]="'yy-mm-dd'"
                [inputId]="'emissionDateEnd'" [formControlName]="'emissionDateEnd'"></p-calendar>
        </div>

        <div class="ui-g-6 ui-md-6 form-control">
            <span class="label">{{ 'campaign.fruitionStartDate' | translate }}</span>
            <p-calendar #fruitionStartField data-testid="fruitionStartField" [showIcon]="true" [inputStyleClass]="'form-control'"
                [dateFormat]="'yy-mm-dd'" [inputId]="'fruitionDateStart'"
                [formControlName]="'fruitionDateStart'"></p-calendar>
        </div>

        <div class="ui-g-6 ui-md-6 form-control">
            <span class="label">{{ 'campaign.fruitionEndDate' | translate }}</span>
            <p-calendar #fruitionEndField data-testid="fruitionEndField" [showIcon]="true" [inputStyleClass]="'form-control'" [dateFormat]="'yy-mm-dd'"
                [inputId]="'fruitionDateEnd'" [formControlName]="'fruitionDateEnd'"></p-calendar>
        </div>


    </div>
    <div class="ui-g-12 text-center">
        <span class="input-error-notification" *ngIf="datesError">
            {{ 'campaign.couponDatesError' | translate }}
        </span>
        <button class="k-generic-btn" type="button" pButton icon="fa fa-check" label="{{'common.save' | translate}}"
            (click)="save()">
        </button>
    </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/coupon-form-3/coupon-form-3.component.html